<!--  -->
<template>
  <div v-if="isSize" class="box">
    <el-upload
      :headers="token"
      class="avatar-uploader"
      :action="uploadUrl"
      :show-file-list="false"
      :on-success="handleAvatarSuccess"
      :accept="accept"
      :disabled="isDisabled"
      :data="uploadData"
    >
      <div v-if="imageUrl">
        <img :src="imageUrl" class="avatar" />
      </div>
      <el-icon v-else class="avatar-uploader-icon"><Plus /></el-icon>
    </el-upload>
  </div>
  <div v-else class="box">
    <el-upload
      ref="upload"
      v-model:file-list="imageUrlList"
      :class="{ hide_box: imageUrlList.length == limit }"
      :headers="token"
      :limit="limit"
      :action="uploadUrl"
      :list-type="type"
      :on-preview="handlePictureCardPreview"
      :on-success="handleSuccess"
      :before-upload="onBeforeImgUpload"
      :accept="accept"
      :disabled="isDisabled"
      :data="uploadData"
      multiple
    >
      <el-icon class="avatar-uploader-icon">
        <Plus />
      </el-icon>
    </el-upload>

    <el-image-viewer
      v-if="dialogVisible"
      :url-list="[dialogImageUrl]"
      @close="() => (dialogVisible = false)"
    ></el-image-viewer>
  </div>
</template>

<script lang="ts" setup>
import { ref, onMounted, watch, getCurrentInstance, Ref } from "vue";
import { Plus } from "@element-plus/icons-vue";
import type {
  UploadProps,
  UploadFile,
  UploadFiles,
  UploadRawFile,
} from "element-plus";

const emit = defineEmits<{
  (event: "getImage", params: string): void;
  (event: "update:urlList", params: UploadFiles): void;
  (event: "update:url", params: string): void;
}>();

const props = defineProps({
  url: {
    type: String,
    default: "",
  },
  limit: {
    type: Number,
    default: 1,
  },
  urlList: {
    type: Array,
    default: () => {
      return [];
    },
  },
  isSize: {
    // 注意 ： 传false
    type: Boolean,
    default: true,
  },
  type: {
    // 图片类型 默认图片
    type: String,
    default: "picture-card",
  },
  accept: {
    // 上传的类型 默认接受全部类型
    type: String,
    default: "",
  },
  size: {
    // 图片大小
    type: Number,
    default: -1,
  },
  // 上传地址
  uploadUrl: {
    type: String,
    default: "/auth/system/file/upload",
  },
  // 是否禁用
  isDisabled: {
    type: Boolean,
    default: false,
  },
  // 上传参数
  uploadData: {
    type: Object,
    default: () => {
      return {};
    },
  },
});

const app = getCurrentInstance()?.proxy;

const token = ref({
  Authorization: localStorage.getItem("token"),
});
const imageUrl = ref<string>("");
const imageUrlList: Ref<any[]> = ref([]);
const dialogImageUrl = ref("");
const dialogVisible = ref(false);

const handleSuccess = (
  response: any,
  uploadFile: UploadFile,
  uploadFiles: any
) => {
  if (response.code == 200) {
    imageUrlList.value = uploadFiles.map((v: any) => {
      if (v.response) {
        if (v.response.data.url.includes("https")) {
          v.url = v.response.data.url;
          // 微信小程序需要图片ID 其余地方用不到
          v.id = v.response.data?.wxMediaId || "";
        } else {
          v.url = `https://wepaas.oss-cn-shenzhen.aliyuncs.com/${v.response.data.url}`;
          // 微信小程序需要图片ID 其余地方用不到
          v.id = v.response.data?.wxMediaId || "";
        }
      }
      return v;
    });
  } else {
    app?.$message.error(response.message);
    let index = imageUrlList.value.findIndex(
      (v: any) => v.uid == uploadFile.uid
    );
    if (index != -1) {
      imageUrlList.value.splice(index, 1);
    }
  }
  emit("update:urlList", imageUrlList.value);
};

const handlePictureCardPreview: UploadProps["onPreview"] = (uploadFile) => {
  if (props.type == "picture-card") {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    dialogImageUrl.value = uploadFile.url!;
    dialogVisible.value = true;
  }
};

const onBeforeImgUpload = (rawFile: UploadRawFile) => {
  const imgSize = rawFile.size;
  console.log(imgSize / 1024 / 1024 > props.size);
  console.log(imgSize / 1024 / 1024);
  console.log(props);

  if (props.size != -1 && imgSize / 1024 / 1024 > props.size) {
    app?.$message.error(`图片最大可上传${props.size}M`);
    return false;
  }
  return true;
};

onMounted(() => {
  imageUrl.value = props.url;
  imageUrlList.value = props.urlList;
});
const handleAvatarSuccess = (response: any) => {
  imageUrl.value =
    "https://wepaas.oss-cn-shenzhen.aliyuncs.com/" + response.data.url;
  emit("update:url", imageUrl.value);
};

const upload = ref();

watch(
  () => props.url,
  () => {
    imageUrl.value = props.url;
  }
);
watch(
  () => props.urlList,
  () => {
    imageUrlList.value = props.urlList;
  }
);

defineExpose({
  imageUrl,
  imageUrlList,
});

// :before-upload="beforeAvatarUpload"
// const beforeAvatarUpload: UploadProps["beforeUpload"] = (rawFile) => {
// if (rawFile.type !== "image/jpeg") {
//   ElMessage.error("Avatar picture must be JPG format!");
//   return false;
// } else if (rawFile.size / 1024 / 1024 > 2) {
//   ElMessage.error("Avatar picture size can not exceed 2MB!");
//   return false;
// }
// return true;
// };
</script>
<style lang="scss" scoped>
:deep(.el-upload--picture-card) {
  width: 80px;
  height: 80px;
}
:deep(.el-upload-list--picture-card .el-upload-list__item) {
  width: 80px;
  height: 80px;
}
.box {
  margin-right: 20px;
}

:deep(.el-dialog__body) {
  text-align: center;
  border: 0 !important;
}
.avatar-uploader {
  border-radius: 6px;
  width: 80px;
  height: 80px;
}
.avatar-uploader .avatar {
  width: 80px;
  height: 80px;
  display: block;
  border-radius: 6px;
}
.avatar-uploader .el-upload {
  border: 1px solid #d1d4d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: 0.5s;
}

.avatar-uploader .el-upload:hover {
  border: 1px solid #d1d4d9;
}

.hide_box :deep(.el-upload--picture-card) {
  display: none;
}

.el-icon.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 80px;
  height: 80px;
  text-align: center;
}
.title {
  font-size: 12px;
  font-weight: 400;
  color: #a3a9b4;
}
:deep(.el-upload--text) {
  border: 1px dashed #cdd0d6;
  background-color: #fafafa;
  border-radius: 6px;
}
:deep(.el-upload--text):hover {
  border: 1px dashed #409eff;
}
</style>
